import { forwardRef } from 'react';
import * as RadixLabel from '@radix-ui/react-label';
import { cn } from '@/lib/cn';

type LabelProps = React.ComponentPropsWithoutRef<typeof RadixLabel.Root>;

export const Label = forwardRef<HTMLLabelElement, LabelProps>(function Label(
  { className, ...rest },
  ref,
) {
  return (
    <RadixLabel.Root
      ref={ref}
      className={cn('text-sm font-medium text-parchment-ink', className)}
      {...rest}
    />
  );
});
